var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3832_825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3065 36.5776C51.923 35.7695 51.3956 34.5443 50.4313 34.5443H39.1071C38.2949 34.5443 37.7441 33.6438 38.0566 32.8267L42.1977 21.9976C42.7002 20.6836 38.4769 19.6329 37.6418 20.7275L23.1106 43.2225C22.4941 44.0306 23.0214 45.2558 23.9858 45.2558H35.3099C36.1221 45.2558 36.6729 46.1563 36.3605 46.9733L29.5892 58.519C29.0867 59.833 33.31 60.1672 34.1451 59.0726L51.3065 36.5776Z",
    fill: "#00B470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.461 36.5776C49.0775 35.7695 48.5502 34.5443 47.5858 34.5443H36.2616C35.4495 34.5443 34.8987 33.6438 35.2111 32.8267L39.3522 21.9976C39.8547 20.6836 38.2616 19.6329 37.4265 20.7275L20.2651 43.2225C19.6486 44.0306 20.1759 45.2558 21.1403 45.2558H32.4645C33.2767 45.2558 33.8275 46.1563 33.515 46.9733L29.3739 57.8024C28.8714 59.1164 30.4645 60.1672 31.2996 59.0726L48.461 36.5776Z",
    fill: "#30FFB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6928 36.008L47.36 35.6582C47.36 35.6582 41.981 39.0883 37.7066 40.9048C33.9243 42.5121 26.7217 44.4025 26.7217 44.4025H32.3806C32.7134 44.4025 33.3792 44.4025 34.0449 45.4518C34.4627 46.1103 34.0449 47.2006 33.7121 47.9002L30.7162 55.9449L32.3806 56.6444L47.6928 36.008Z",
    fill: "#2EF2A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3709 37.0804C46.7202 36.6225 46.41 35.9433 45.8514 35.9433H36.2616C34.4338 35.9433 33.3392 33.9694 33.9756 32.3051L35.9908 27.0352C36.2765 26.2883 35.3328 25.7088 34.8537 26.3369L22.3552 42.7196C22.0059 43.1776 22.3162 43.8567 22.8747 43.8567H32.4645C34.2923 43.8567 35.3869 45.8307 34.7505 47.495L32.7353 52.7648C32.4497 53.5117 33.3934 54.0912 33.8725 53.4632L46.3709 37.0804ZM47.5858 34.5443C48.5502 34.5443 49.0775 35.7695 48.461 36.5776L31.2996 59.0726C30.4645 60.1672 28.8714 59.1164 29.3739 57.8024L33.515 46.9733C33.8275 46.1563 33.2767 45.2558 32.4645 45.2558H21.1403C20.1759 45.2558 19.6486 44.0306 20.2651 43.2225L37.4265 20.7275C38.2616 19.6329 39.8547 20.6836 39.3522 21.9976L35.2111 32.8267C34.8987 33.6438 35.4495 34.5443 36.2616 34.5443H47.5858Z",
    fill: "#01D787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0422 37.7192C36.0422 37.356 36.3403 37.0615 36.708 37.0615H43.3655C43.7332 37.0615 44.0312 37.356 44.0312 37.7192C44.0312 38.0824 43.7332 38.3768 43.3655 38.3768H36.708C36.3403 38.3768 36.0422 38.0824 36.0422 37.7192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9818 42.5519C23.7041 42.3172 23.6658 41.8829 23.8963 41.5819L33.2814 29.3227C33.5118 29.0217 33.9238 28.9679 34.2014 29.2026C34.4791 29.4373 34.5174 29.8716 34.2869 30.1727L24.9019 42.4318C24.6714 42.7329 24.2595 42.7866 23.9818 42.5519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3832_825",
    x: 0,
    y: 0.270508,
    width: 71.5715,
    height: 79.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 1 0 0 0 0 0.694118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3832_825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3832_825",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLightning);
export default __webpack_public_path__ + "static/media/green_lightning.4673af9f981322e5d0558711ae0ead77.svg";
export { ForwardRef as ReactComponent };